/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticket_Action_Claim_PartsInputs */

const en_ticket_action_claim_parts = /** @type {(inputs: Ticket_Action_Claim_PartsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Claim Parts`)
};

const ja_ticket_action_claim_parts = /** @type {(inputs: Ticket_Action_Claim_PartsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`部品を受領`)
};

const fr_ticket_action_claim_parts = /** @type {(inputs: Ticket_Action_Claim_PartsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Récupérer les pièces`)
};

const de_ticket_action_claim_parts = /** @type {(inputs: Ticket_Action_Claim_PartsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teile abholen`)
};

/**
* | output |
* | --- |
* | "Claim Parts" |
*
* @param {Ticket_Action_Claim_PartsInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const ticket_action_claim_parts = /** @type {((inputs?: Ticket_Action_Claim_PartsInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticket_Action_Claim_PartsInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticket_action_claim_parts(inputs)
	if (locale === "ja") return ja_ticket_action_claim_parts(inputs)
	if (locale === "fr") return fr_ticket_action_claim_parts(inputs)
	return de_ticket_action_claim_parts(inputs)
});